import { useTheme } from "@hooks";

export const Plus = () => {
  const { theme } = useTheme();

  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="17.5"
        cy="17.182"
        r="17"
        fill={theme.chart.projection.default.adjuster.background}
      />
      <path
        d="M16.4941 21.9882V13.1416H18.5012V21.9882H16.4941ZM13.0743 18.5684V16.5613H21.9209V18.5684H13.0743Z"
        fill={theme.chart.projection.default.adjuster.fill}
      />
    </svg>
  );
};
